// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.general-settings-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-tertiary);
  cursor: pointer;
  user-select: none;
}

.general-settings-row:last-child {
  border-bottom: none;
}

.general-settings-row:hover {
  background: var(--color-brand-hover2, #f9e2d6);
}

.general-settings-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: #7f7f7f;
}

.general-settings-icon svg {
  width: 20px;
  height: 20px;
}

@container (max-width: 600px) {
  .general-settings-popup {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/settings/GeneralSettings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".general-settings-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-tertiary);\n  cursor: pointer;\n  user-select: none;\n}\n\n.general-settings-row:last-child {\n  border-bottom: none;\n}\n\n.general-settings-row:hover {\n  background: var(--color-brand-hover2, #f9e2d6);\n}\n\n.general-settings-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  color: #7f7f7f;\n}\n\n.general-settings-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n@container (max-width: 600px) {\n  .general-settings-popup {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
